import { render, staticRenderFns } from "./CommandTypeList.vue?vue&type=template&id=5683e278"
import script from "./CommandTypeList.vue?vue&type=script&lang=js"
export * from "./CommandTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports